module.exports = __webpack_public_path__ + "static/media/IconTemplates_-83.adca14f0.svg";